var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _dec5, _dec6, _class2, _descriptor5, _descriptor6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _class3, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _dec12, _dec13, _class4, _descriptor12, _descriptor13, _dec14, _dec15, _class5, _descriptor14, _descriptor15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _class6, _class7, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import objectTrait from "../Decorators/objectTrait";
import primitiveArrayTrait from "../Decorators/primitiveArrayTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import { traitClass } from "../Trait";
import CatalogMemberTraits from "./CatalogMemberTraits";
import DiffableTraits from "./DiffableTraits";
import ExportWebCoverageServiceTraits from "./ExportWebCoverageServiceTraits";
import GetCapabilitiesTraits from "./GetCapabilitiesTraits";
import ImageryProviderTraits from "./ImageryProviderTraits";
import LayerOrderingTraits from "./LayerOrderingTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import LegendTraits from "./LegendTraits";
import MappableTraits from "./MappableTraits";
import { MinMaxLevelTraits } from "./MinMaxLevelTraits";
import UrlTraits from "./UrlTraits";
export const SUPPORTED_CRS_3857 = ["EPSG:3857", "EPSG:900913"];
export const SUPPORTED_CRS_4326 = ["EPSG:4326", "CRS:84", "EPSG:4283"];
export let WebMapServiceAvailableStyleTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Style Name",
  description: "The name of the style."
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Title",
  description: "The title of the style."
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Abstract",
  description: "The abstract describing the style."
}), _dec4 = objectTrait({
  type: LegendTraits,
  name: "Style Name",
  description: "The name of the style."
}), _class = class WebMapServiceAvailableStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "title", _descriptor2, this);
    _initializerDefineProperty(this, "abstract", _descriptor3, this);
    _initializerDefineProperty(this, "legend", _descriptor4, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "title", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "abstract", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "legend", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export let WebMapServiceAvailableLayerStylesTraits = (_dec5 = primitiveTrait({
  type: "string",
  name: "Layer Name",
  description: "The name of the layer for which styles are available."
}), _dec6 = objectArrayTrait({
  type: WebMapServiceAvailableStyleTraits,
  name: "Styles",
  description: "The styles available for this layer.",
  idProperty: "name"
}), _class2 = class WebMapServiceAvailableLayerStylesTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "layerName", _descriptor5, this);
    _initializerDefineProperty(this, "styles", _descriptor6, this);
  }
}, _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "layerName", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "styles", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export let WebMapServiceAvailableDimensionTraits = (_dec7 = primitiveTrait({
  type: "string",
  name: "Dimension Name",
  description: "The name of the dimension."
}), _dec8 = primitiveArrayTrait({
  type: "string",
  name: "Dimension values",
  description: "Possible dimension values."
}), _dec9 = primitiveTrait({
  type: "string",
  name: "Units",
  description: "The units of the dimension."
}), _dec0 = primitiveTrait({
  type: "string",
  name: "Unit Symbol",
  description: "The unitSymbol of the dimension."
}), _dec1 = primitiveTrait({
  type: "string",
  name: "Default",
  description: "The default value for the dimension."
}), _dec10 = primitiveTrait({
  type: "boolean",
  name: "Multiple Values",
  description: "Can the dimension support multiple values."
}), _dec11 = primitiveTrait({
  type: "boolean",
  name: "Nearest Value",
  description: "The nearest value of the dimension."
}), _class3 = class WebMapServiceAvailableDimensionTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor7, this);
    _initializerDefineProperty(this, "values", _descriptor8, this);
    _initializerDefineProperty(this, "units", _descriptor9, this);
    _initializerDefineProperty(this, "unitSymbol", _descriptor0, this);
    _initializerDefineProperty(this, "default", _descriptor1, this);
    _initializerDefineProperty(this, "multipleValues", _descriptor10, this);
    _initializerDefineProperty(this, "nearestValue", _descriptor11, this);
  }
}, _descriptor7 = _applyDecoratedDescriptor(_class3.prototype, "name", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class3.prototype, "values", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class3.prototype, "units", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class3.prototype, "unitSymbol", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class3.prototype, "default", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class3.prototype, "multipleValues", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class3.prototype, "nearestValue", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class3);
export let WebMapServiceAvailableLayerDimensionsTraits = (_dec12 = primitiveTrait({
  type: "string",
  name: "Layer Name",
  description: "The name of the layer for which dimensions are available."
}), _dec13 = objectArrayTrait({
  type: WebMapServiceAvailableDimensionTraits,
  name: "Dimensions",
  description: "The dimensions available for this layer.",
  idProperty: "name"
}), _class4 = class WebMapServiceAvailableLayerDimensionsTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "layerName", _descriptor12, this);
    _initializerDefineProperty(this, "dimensions", _descriptor13, this);
  }
}, _descriptor12 = _applyDecoratedDescriptor(_class4.prototype, "layerName", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class4.prototype, "dimensions", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class4);
export let GetFeatureInfoFormat = (_dec14 = primitiveTrait({
  type: "string",
  name: "Type",
  description: "The type of response to expect from a GetFeatureInfo request.  Valid values are 'json', 'xml', 'html', 'text' or 'csv'. If type is 'csv', then featureInfoContext will contain timeSeries object (see \"Customizing the Feature Info Template\" in documentation)"
}), _dec15 = primitiveTrait({
  type: "string",
  name: "Format",
  description: "The info format to request from the WMS server.  This is usually a MIME type such as 'application/json' or text/xml'.  If this parameter is not specified, the provider will request 'json' using 'application/json', 'xml' using 'text/xml', 'html' using 'text/html', and 'text' using 'text/plain'."
}), _class5 = class GetFeatureInfoFormat extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "type", _descriptor14, this);
    _initializerDefineProperty(this, "format", _descriptor15, this);
  }
}, _descriptor14 = _applyDecoratedDescriptor(_class5.prototype, "type", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class5.prototype, "format", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class5);
let WebMapServiceCatalogItemTraits = (_dec16 = traitClass({
  description: "Creates a single item in the catalog from one or many WMS layers.\n\n<strong>Note:</strong> <i>To present all layers in an available WMS as individual items in the catalog use the `WebMapServiceCatalogGroup`.</i>",
  example: {
    type: "wms",
    name: "Mangrove Cover",
    url: "https://ows.services.dea.ga.gov.au",
    layers: "mangrove_cover_v2_0_2"
  }
}), _dec17 = primitiveTrait({
  type: "string",
  name: "Layer(s)",
  description: "The layer or layers to display (comma separated values)."
}), _dec18 = primitiveTrait({
  type: "string",
  name: "Style(s)",
  description: "The styles to use with each of the `Layer(s)` (comma separated values). This maps one-to-one with `Layer(s)`"
}), _dec19 = primitiveTrait({
  type: "string",
  name: "Style(s)",
  description: "CRS to use with WMS layers. We support Web Mercator (".concat(SUPPORTED_CRS_3857.join(", "), ") and WGS 84 (").concat(SUPPORTED_CRS_4326.join(", "), ")")
}), _dec20 = anyTrait({
  name: "Dimensions",
  description: "Dimension parameters used to request a particular layer along one or more dimensional axes (including elevation, excluding time). Do not include `_dim` prefx for parameter keys. These dimensions will be applied to all layers (if applicable)"
}), _dec21 = objectArrayTrait({
  type: WebMapServiceAvailableLayerStylesTraits,
  name: "Available Styles",
  description: "The available styles.",
  idProperty: "layerName"
}), _dec22 = objectArrayTrait({
  type: WebMapServiceAvailableLayerDimensionsTraits,
  name: "Available Dimensions",
  description: "The available dimensions.",
  idProperty: "layerName"
}), _dec23 = anyTrait({
  name: "Parameters",
  description: "Additional parameters to pass WMS `GetMap` and `GetFeatureInfo` requests. Style parameters are stored as CSV in `styles`, dimension parameters are stored in `dimensions`."
}), _dec24 = primitiveTrait({
  type: "number",
  name: "Maximum Refresh Intervals",
  description: "The maximum number of discrete times that can be created by a single " + "date range, when specified in the format time/time/periodicity. E.g. " + "`2015-04-27T16:15:00/2015-04-27T18:45:00/PT15M` has 11 times."
}), _dec25 = primitiveTrait({
  type: "boolean",
  name: "Disable dimension selectors",
  description: "When true, disables the dimension selectors in the workbench."
}), _dec26 = primitiveTrait({
  type: "boolean",
  name: "Is GeoServer",
  description: "True if this WMS is a GeoServer; otherwise, false."
}), _dec27 = primitiveTrait({
  type: "boolean",
  name: "Is Esri",
  description: "True if this WMS is from Esri; otherwise, false."
}), _dec28 = primitiveTrait({
  type: "boolean",
  name: "Is Thredds",
  description: "True if this WMS is from a THREDDS server; otherwise, false."
}), _dec29 = primitiveTrait({
  type: "boolean",
  name: "Is NcWMS",
  description: "True if this WMS supports NcWMS."
}), _dec30 = primitiveTrait({
  type: "boolean",
  name: "Supports color scale range",
  description: "Gets or sets whether this WMS server has been identified as supporting the COLORSCALERANGE parameter."
}), _dec31 = primitiveTrait({
  type: "boolean",
  name: "Supports GetLegendGraphic requests",
  description: "Gets or sets whether this WMS server supports GetLegendGraphic requests."
}), _dec32 = primitiveTrait({
  type: "boolean",
  name: "Supports GetTimeseries requests",
  description: 'Gets or sets whether this WMS server supports GetTimeseries requests. If true, then GetTimeseries will be used instead of GetFeatureInfo. This will also set default value of `getFeatureInfoFormat` to `{ format: "text/csv", type: "text" }`'
}), _dec33 = primitiveTrait({
  type: "number",
  name: "Color scale minimum",
  description: "The minimum of the color scale range. Because COLORSCALERANGE is a non-standard property supported by ncWMS servers, this property is ignored unless WebMapServiceCatalogItem's supportsColorScaleRange is true. WebMapServiceCatalogItem's colorScaleMaximum must be set as well."
}), _dec34 = primitiveTrait({
  type: "number",
  name: "Color scale maximum",
  description: "The maximum of the color scale range. Because COLORSCALERANGE is a non-standard property supported by ncWMS servers, this property is ignored unless WebMapServiceCatalogItem's supportsColorScaleRange is true. WebMapServiceCatalogItem's colorScaleMinimum must be set as well."
}), _dec35 = primitiveTrait({
  type: "boolean",
  name: "Use WMS version 1.3.0",
  description: 'Use WMS version 1.3.0. True by default (unless `url` has `"version=1.1.1"` or `"version=1.1.0"`), if false, then WMS version 1.1.1 will be used.'
}), _dec36 = objectTrait({
  type: GetFeatureInfoFormat,
  name: "GetFeatureInfo format",
  description: 'Format parameter to pass to GetFeatureInfo requests. Defaults to "application/json", "application/vnd.ogc.gml", "text/html" or "text/plain" - depending on GetCapabilities response'
}), _dec37 = primitiveTrait({
  type: "string",
  name: "GetFeatureInfo URL",
  description: "If defined, this URL will be used for `GetFeatureInfo` requests instead of `url`."
}), _dec38 = anyTrait({
  name: "Parameters",
  description: "Additional parameters to pass WMS `GetFeatureInfo` requests. If `parameters` trait is also defined, this is applied on top. Dimension parameters are stored in `dimensions`."
}), _dec16(_class6 = (_class7 = class WebMapServiceCatalogItemTraits extends mixTraits(ExportWebCoverageServiceTraits, DiffableTraits, LayerOrderingTraits, GetCapabilitiesTraits, ImageryProviderTraits, UrlTraits, MappableTraits, CatalogMemberTraits, LegendOwnerTraits, MinMaxLevelTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "layers", _descriptor16, this);
    _initializerDefineProperty(this, "styles", _descriptor17, this);
    _initializerDefineProperty(this, "crs", _descriptor18, this);
    _initializerDefineProperty(this, "dimensions", _descriptor19, this);
    _initializerDefineProperty(this, "availableStyles", _descriptor20, this);
    _initializerDefineProperty(this, "availableDimensions", _descriptor21, this);
    _initializerDefineProperty(this, "parameters", _descriptor22, this);
    _initializerDefineProperty(this, "maxRefreshIntervals", _descriptor23, this);
    _initializerDefineProperty(this, "disableDimensionSelectors", _descriptor24, this);
    _initializerDefineProperty(this, "isGeoServer", _descriptor25, this);
    _initializerDefineProperty(this, "isEsri", _descriptor26, this);
    _initializerDefineProperty(this, "isThredds", _descriptor27, this);
    _initializerDefineProperty(this, "isNcWMS", _descriptor28, this);
    _initializerDefineProperty(this, "supportsColorScaleRange", _descriptor29, this);
    _initializerDefineProperty(this, "supportsGetLegendGraphic", _descriptor30, this);
    _initializerDefineProperty(this, "supportsGetTimeseries", _descriptor31, this);
    _initializerDefineProperty(this, "colorScaleMinimum", _descriptor32, this);
    _initializerDefineProperty(this, "colorScaleMaximum", _descriptor33, this);
    _initializerDefineProperty(this, "useWmsVersion130", _descriptor34, this);
    _initializerDefineProperty(this, "getFeatureInfoFormat", _descriptor35, this);
    _initializerDefineProperty(this, "getFeatureInfoUrl", _descriptor36, this);
    _initializerDefineProperty(this, "getFeatureInfoParameters", _descriptor37, this);
  }
}, _descriptor16 = _applyDecoratedDescriptor(_class7.prototype, "layers", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class7.prototype, "styles", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class7.prototype, "crs", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class7.prototype, "dimensions", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class7.prototype, "availableStyles", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class7.prototype, "availableDimensions", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class7.prototype, "parameters", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class7.prototype, "maxRefreshIntervals", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 10000;
  }
}), _descriptor24 = _applyDecoratedDescriptor(_class7.prototype, "disableDimensionSelectors", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor25 = _applyDecoratedDescriptor(_class7.prototype, "isGeoServer", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor26 = _applyDecoratedDescriptor(_class7.prototype, "isEsri", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor27 = _applyDecoratedDescriptor(_class7.prototype, "isThredds", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor28 = _applyDecoratedDescriptor(_class7.prototype, "isNcWMS", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor29 = _applyDecoratedDescriptor(_class7.prototype, "supportsColorScaleRange", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor30 = _applyDecoratedDescriptor(_class7.prototype, "supportsGetLegendGraphic", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor31 = _applyDecoratedDescriptor(_class7.prototype, "supportsGetTimeseries", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor32 = _applyDecoratedDescriptor(_class7.prototype, "colorScaleMinimum", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return -50;
  }
}), _descriptor33 = _applyDecoratedDescriptor(_class7.prototype, "colorScaleMaximum", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 50;
  }
}), _descriptor34 = _applyDecoratedDescriptor(_class7.prototype, "useWmsVersion130", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor35 = _applyDecoratedDescriptor(_class7.prototype, "getFeatureInfoFormat", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class7.prototype, "getFeatureInfoUrl", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class7.prototype, "getFeatureInfoParameters", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class7)) || _class6);
export { WebMapServiceCatalogItemTraits as default };